module.exports = __webpack_public_path__ + "img/logo-personal-appointment.f9b0eaa7.png";